import { createContext, useContext } from 'react';

import {
  GCFProductsContextProps,
  LocationGroupScheduleComponentContextProps,
  LocationScheduleComponentContextProps,
  OOLocationAssemblyOverridesContextProps,
  ScheduleLocationOverridesContextProps,
} from './Context.interface';

export const OOLocationAssemblyOverridesContext =
  createContext<OOLocationAssemblyOverridesContextProps>(
    {} as OOLocationAssemblyOverridesContextProps,
  );

export const GCFProductsContext = createContext<GCFProductsContextProps>(
  {} as GCFProductsContextProps,
);

export const LocationScheduleComponentContext =
  createContext<LocationScheduleComponentContextProps>(
    {} as LocationScheduleComponentContextProps,
  );

export const LocationGroupScheduleComponentContext =
  createContext<LocationGroupScheduleComponentContextProps>(
    {} as LocationGroupScheduleComponentContextProps,
  );

export const ScheduleLocationOverridesContext =
  createContext<ScheduleLocationOverridesContextProps>(
    {} as ScheduleLocationOverridesContextProps,
  );
export const useScheduleLocationOverridesContext = () =>
  useContext(ScheduleLocationOverridesContext);
